import { InputMessageStyle } from "./styles";

export type InputMessageVariant = "error" | "helper" | "warning";

export type InputMessageProps = React.HTMLProps<HTMLParagraphElement> & {
  variant: InputMessageVariant;
};

export const InputMessage = ({ variant, ...props }: InputMessageProps) => {
  return <InputMessageStyle variant={variant} {...props} />;
};
